module.exports = __webpack_public_path__ + "img/add-group.5b61b171.svg";